// extracted by mini-css-extract-plugin
module.exports = {"box":"mainForTerms_box__Tohjt","box__header":"mainForTerms_box__header__1wkjP"};